//
// Login:
//

export const index = {
    path   : '/stock_prices/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/stock_prices/:stock_prices_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/stock_prices/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/stock_prices/:stock_prices_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/stock_prices/:stock_prices_id/',
  method : 'DELETE',
  version: '/v1'
}
